import * as dayjs from 'dayjs';
dayjs().format();

export function sameDay(date1: Date, date2: Date = new Date()): boolean {
    return dayjs(date1).isSame(date2, 'day');
}

export function yestrday(date1: Date, date2: Date = new Date()): boolean {
    return dayjs(date2).subtract(1, 'day').isSame(date1, 'day');
}

export function dateFormatIS(date: Date): string {
    return dayjs(date).format('DD.MM.YYYY');
}

export function periodToDate(period: string | number): { fromDate: Date; toDate: Date } {
    const today: dayjs.Dayjs = dayjs();
    let newFromDate: dayjs.Dayjs;
    let newToDate: dayjs.Dayjs;

    // 1 היום
    // 2 אתמול
    // 3 7 ימים אחרונים
    // 4 30 ימים אחרונים
    // 5 החודש
    // 6 החודש הקודם
    // 7 חודשיים מלאים
    // 8 מתחילת שנה
    switch (period) {
        case '1':
        case 1:
            newFromDate = today.startOf('day');
            newToDate = today.endOf('day');
            break;
        case '2':
        case 2:
            newFromDate = today.subtract(1, 'day').startOf('day');
            newToDate = today.subtract(1, 'day').endOf('day');
            break;
        case '3':
        case 3:
            newFromDate = today.subtract(6, 'day').startOf('day');
            newToDate = today.endOf('day');
            break;
        case '4':
        case 4:
            newFromDate = today.subtract(29, 'day').startOf('day');
            newToDate = today.endOf('day');
            break;
        case '5':
        case 5:
            newFromDate = today.startOf('month');
            newToDate = today.endOf('day');
            break;
        case '6':
        case 6:
            newFromDate = today.subtract(1, 'month').startOf('month');
            newToDate = newFromDate.endOf('month');
            break;
        case '7':
        case 7:
            newFromDate = today.subtract(1, 'month').startOf('month');
            newToDate = today.endOf('day');
            break;
        case '8':
        case 8:
            newFromDate = today.startOf('year');
            newToDate = today.endOf('day');
            break;
        case '9':
        case 9:
            newFromDate = today.subtract(1, 'year');
            newToDate = today.endOf('day');
            break;

        default:
            break;
    }

    if (period === '1' || period === 1) {
        return {
            fromDate: new Date(),
            toDate: new Date()
        };
    }

    return {
        fromDate: newFromDate?.toDate(),
        toDate: newToDate?.toDate()
    };
}
